import { render, staticRenderFns } from "./CrewFleetStatus.vue?vue&type=template&id=c997bc90&scoped=true"
import script from "./CrewFleetStatus.vue?vue&type=script&lang=js"
export * from "./CrewFleetStatus.vue?vue&type=script&lang=js"
import style0 from "./CrewFleetStatus.vue?vue&type=style&index=0&id=c997bc90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c997bc90",
  null
  
)

export default component.exports